import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { Heading } from "../heading/heading.es.js";
const propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  noWrap: PropTypes.bool
};
const defaultProps = {
  as: "h1",
  noWrap: false
};
const H1 = forwardRef(({ as, children, noWrap }, ref) => {
  console.warn("H1 component is deprecated. Use Heading instead.");
  return /* @__PURE__ */ jsx(Heading, { ref, as, noWrap, size: "xlarge", children });
});
H1.propTypes = propTypes;
H1.defaultProps = defaultProps;
export {
  H1
};
